import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { DesignStructure } from '@gelato-api-ui/core/designs/design-structure';
import { PreflightProductPreviewRequest } from '../preflight-product-preview-request';
import { PreviewFileType } from '../preview-file-type.enum';
import { PreflightApiService } from './preflight-api.service';
import { DesignProductPreviewUrlParamsProvider } from '@gelato-api-ui/core/preflight/services/design-product-preview-url-params.provider';
import { PreflightProductPreviewRequestProvider } from '@gelato-api-ui/core/preflight/services/preflight-product-preview-request.provider';

@Injectable({ providedIn: 'root' })
export class DesignProductPreviewService {
  constructor(
    private readonly preflightApiService: PreflightApiService,
    private readonly designProductPreviewUrlParamsProvider: DesignProductPreviewUrlParamsProvider,
    private readonly preflightProductPreviewRequestProvider: PreflightProductPreviewRequestProvider,
  ) {}

  getPreviewUrl(
    productUid: string,
    designStructure: DesignStructure,
    previewScene: string,
    previewFileType: PreviewFileType,
    designPreviewFileType: PreviewFileType,
    width: number,
    height: number,
    removeSamples: boolean,
    forceDimensions: boolean,
  ): Observable<string> {
    return this.getPreviewRequest(
      productUid,
      designStructure,
      previewScene,
      previewFileType,
      designPreviewFileType,
      width,
      height,
      removeSamples,
      forceDimensions,
    ).pipe(
      first(),
      map(request => this.preflightApiService.getProductPreviewUrlDeprecated(request)),
    );
  }

  getPreviewRequest(
    productUid: string,
    designStructure: DesignStructure,
    previewScene: string,
    previewFileType: PreviewFileType,
    designPreviewFileType: PreviewFileType,
    width: number,
    height: number,
    removeSamples: boolean,
    forceDimensions: boolean,
  ): Observable<PreflightProductPreviewRequest> {
    return this.designProductPreviewUrlParamsProvider
      .get(productUid, designStructure, designPreviewFileType, width, height, removeSamples)
      .pipe(
        map(designPreviewUrlParams =>
          this.preflightProductPreviewRequestProvider.get(
            productUid,
            designPreviewUrlParams,
            width,
            height,
            previewScene,
            forceDimensions,
            previewFileType,
          ),
        ),
      );
  }
}
